import { Redirect } from 'expo-router';

export default function IndexScreen() {
  return <Redirect withAnchor href="/(auth)/login" />;
}
